import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authConfig, setAuthConfig] = useState({
    mode: "hybrid",
    external_login_enabled: true,
    local_login_enabled: true,
  });

  const fetchConfig = useCallback(async () => {
    try {
      const { data } = await api.get("/meta");
      if (data?.auth) {
        setAuthConfig((prev) => ({ ...prev, ...data.auth }));
      }
    } catch {
      // keep the default client-side fallback config
    }
  }, []);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
    // Skip /me check if we're returning from the OAuth callback (handled by AuthCallback)
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    fetchMe();
  }, [fetchConfig, fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fh_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("fh_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogle = () => {
    if (!authConfig.external_login_enabled) {
      throw new Error("Autentificarea externă este dezactivată");
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("fh_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, authConfig, login, register, logout, loginWithGoogle, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
